<template>
    <div v-if="selectList.isVisible" @closeMenu="closeSelelectList()">
        <div class="overlay" @click="closeSelectList"></div>
        <div class="content-wrapper">
            <div class="content-header">
                <div>
                    <h1> {{ selectList.title }}</h1>
                </div>
                <div class="search">
                    <label for="search">Buscar:</label>
                    <input type="text" name="search" autocomplete="off" v-model="search" id="search"/>
                </div>
            </div>
            <div class="content-body">
                <div class="result-search" v-if="search && canShowData()">
                    <span v-if="filteredResults().length > 0">Resultados para: {{ `"${search}"` }}</span>
                    <span v-else>Não há resultados para: {{ `"${search}"` }}</span>
                </div>
                <div class="options-container">
                    <div class="options" v-if="selectList.options.length > 0 && canShowData()">
                        <div class="option" v-for="(list, key) in filteredResults()" :key="key" :id="'option' + key" @click="selectOption(list)"><span> {{ list[selectList.optionDisplay] }}</span></div>
                    </div>
                    <div v-else-if="selectList.options.length > 0" class="empty-register">{{ guidancePhrase }}</div>
                    <div v-else class="empty-register"> Sem Registros</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import SwipeModalComponent from './SwipeModalComponent.vue'
export default {
    name: 'SelectList',
    props: ['hideData', 'guidancePhrase'],
    data () {
        return {
            search: ''
        }
    },
    components: {
        // SwipeModalComponent
    },
    computed: {
        ...mapGetters(['selectList'])
    },
    methods: {
        ...mapActions(['closeSelectList']),
        canShowData: function () {
            const hasValidFilteredResults = this.search !== '' && this.search?.length >= 3 &&
                !'colégio '.includes(this.search.toLowerCase()) && !'colegio '.includes(this.search.toLowerCase())
            return !this.hideData || hasValidFilteredResults
        },
        closeSelelectList () {
            this.search = ''
            this.closeSelectList()
        },
        selectOption: function (option) {
            this.$store.dispatch(this.selectList.event, option)
            this.closeSelelectList()
        },
        filteredResults: function () {
            const self = this
            if (self.search) {
                const filteredResults = self.selectList.options.filter((item) => {
                    return item[self.selectList.optionDisplay].toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(self.search.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
                })
                return filteredResults
            }
            return this.selectList.options
        }
    }
}
</script>

<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    background-color: white;
    height: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .content-header {
        display: grid;
        grid-template-columns: auto auto;
        width: 100%;
        border-bottom: solid 3px var(--primaryColor);
        h1 {
            margin: 10px;
            font-size: 20px;
        }
        .search {
            display: flex;
            flex-direction: row;
            align-items: end;
            justify-content: end;
            margin: 10px;
            label {
                margin: 0 10px;
            }
            input {
                border: 0 none;
                border-bottom: solid 1px;
                outline: 0;
                max-width: 50%;
            }
            input:focus {
                outline: 0;
            }
        }
    }
    .content-body {
        margin-bottom: 10px;
        overflow: auto;
        width: 100%;
        .result-search {
            text-align: center;
            padding: 5px;
            border-bottom: solid 1px;
        }
        .options-container {
            .empty-register {
                margin: 10px;
                font-size: 1rem;
                text-align: center;
            }
            .option {
                display: inherit;
                border-bottom: solid 1px;
                span {
                    margin: 10px;
                    display: inherit;
                    align-items: center;
                }
            }
        }
    }
}
&.opened {
        transform: translateY(0);
        // display: block;
    }
.overlay {
    position: fixed;
    top: 0; left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.21);
    z-index: 2;
}

</style>
